import { CONFIG } from '@shared/environment/environment';
export function addDomainOnImagesSrc(helpContent) {
    return {
        ...helpContent,
        ...{
            content: helpContent.content.replaceAll('<img src="/', `<img src="${CONFIG.apiUrl}/`),
        },
    };
}
